
import { Component, OnInit,ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter,MAT_DATE_LOCALE,MAT_DATE_FORMATS } from '@angular/material';
import { FormControl, FormGroup } from '@angular/forms';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { CobranzasService } from '../../../services/cobranzas/cobranzas.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "DD-MM-YYYY",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-listado-pago',
  templateUrl: './listado-pago.component.html',
  styleUrls: ['./listado-pago.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,
    DatePipe,
  
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoPagoComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  flagProformaDetalle : boolean = false;
  abrirDetallePagos : boolean = false;
  
  idProforma : number = 0;
  IdCuota :string;
  form: FormGroup;
  rucAdqFilter = new FormControl('');
  rucProvFilter = new FormControl('');

  proformas : any = [];
  ruc = new FormControl();
  rucAdq = new FormControl();

  
  idProv ="" ;
  idAdq ="";  
  Estado ="";
  user: any;
  dataFiltro : FormGroup;
  dataenviar:any=[];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  pageSizeOptions = [15,20,30,50,100,200];
  loading:boolean;
  displayedColumns: string[] = 
            ['checked','idPago','Fecha','Adquirente','RucAdq','Proveedor','RucProv','Moneda','Importe_cuota','Importe_Ejecutado','Importe_Pendiente','Importe_Ajuste','Estado'];

  filterValues = {
  Adquirente: '',
  Moneda: '',
  Proveedor:'',
  Estado:'',
  Fecha_Inicio:'',
  Fecha_Fin:''
  };          
  dataSource =new MatTableDataSource( this.proformas); 

  constructor( private cobranzasService:CobranzasService,private datePipe :DatePipe) { 
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.dataFiltro = new FormGroup({
      "Moneda":new FormControl(0),
      "Fecha_Inicio": new FormControl(''),
      "Fecha_Fin": new FormControl(''),
      "Estado":new FormControl('')
    });  
  }

  ngOnInit() {
    this.dataenviar.Moneda=0
      
    this.rucAdqFilter.valueChanges
    .subscribe(
      Adquirente => {
        this.filterValues.Adquirente = Adquirente;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )
    this.rucProvFilter.valueChanges
    .subscribe(
      Proveedor => {
        this.filterValues.Proveedor = Proveedor;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    )
      this.dataFiltro.get('Moneda').valueChanges.subscribe(
        Moneda => {
          this.filterValues.Moneda = Moneda;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
      this.dataFiltro.get('Estado').valueChanges.subscribe(
        Estado => {
          this.filterValues.Estado = Estado;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
      this.dataFiltro.get('Fecha_Inicio').valueChanges.subscribe(
        Fecha_Inicio => {
          this.filterValues.Fecha_Inicio = (Fecha_Inicio === null ? "" : this.datePipe.transform(Fecha_Inicio, 'yyyy-MM-dd'));
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
  
      this.dataFiltro.get('Fecha_Fin').valueChanges.subscribe(
        Fecha_Fin => {
          this.filterValues.Fecha_Fin = (Fecha_Fin === null ? "" : this.datePipe.transform(Fecha_Fin, 'yyyy-MM-dd'));
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );

      this.ListadoPagos();  
      const elem=document.getElementById('element-button');
      elem.style.display='none';
  }
  setearEstado(event){

    console.log(event)
    if(event==''){
      this.dataFiltro.controls['Estado'].setValue('')
    }else{
      this.dataFiltro.controls['Estado'].setValue(event)
    } 
  }

  tipoMoneda(event){
    if(event==''){
      this.dataenviar.Moneda=0;
      this.dataFiltro.controls['Moneda'].setValue('')
    }else{
      this.dataenviar.Moneda = event;
      this.dataFiltro.controls['Moneda'].setValue(event)
    } 
  }


  createFilter(): (data: any, filter: string) => boolean {
    return function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);      
      return  data.Adquirente.toString().toLowerCase().indexOf(searchTerms.Adquirente) !== -1
      && data.Proveedor.toString().toLowerCase().indexOf(searchTerms.Proveedor) !== -1
      && data.Moneda.toString().toUpperCase().indexOf(searchTerms.Moneda) !== -1
      && data.Estado.toString().toUpperCase().indexOf(searchTerms.Estado) !== -1
      && data.Fecha >= (searchTerms.Fecha_Inicio == "" ? data.Fecha : searchTerms.Fecha_Inicio)
      && data.Fecha <= (searchTerms.Fecha_Fin == "" ? data.Fecha : searchTerms.Fecha_Fin)
    }
  }
  
  ListadoPagos(){
    if (this.dataFiltro.controls['Fecha_Inicio'].value == "") {
      this.dataenviar.FechaInicio = "1990-01-01";
    }else{
      this.dataenviar.FechaInicio =this.datePipe.transform(this.dataFiltro.controls['Fecha_Inicio'].value,'yyyy-MM-dd');
    }
    if (this.dataFiltro.controls['Fecha_Fin'].value == "") {
      this.dataenviar.FechaFin = "1990-01-01";
    }else{
      this.dataenviar.FechaFin =this.datePipe.transform(this.dataFiltro.controls['Fecha_Fin'].value,'yyyy-MM-dd');      
    }          
    this.dataenviar.Estado =this.dataFiltro.controls['Estado'].value
    
    this.loading = true;    
    this.cobranzasService.FiltroListadoPago(this.dataenviar).subscribe(
      res => {
        console.log('res',res)
        this.proformas = res;
        this.dataSource = new MatTableDataSource( this.proformas);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.createFilter();
          this.loading = false;
        } , err =>{
            Swal.fire({
              title: "¡Algo salió mal!",
              text:  err.error['error'],
              type: "warning",
              allowOutsideClick: true,
              heightAuto: false
            });        
          this.loading = false;
        }
    )
  }

  BajaPago(idPago) {
    Swal.fire({
      title: '',
      text: '¿Estás seguro en dar de baja el pago ' + idPago + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si,dar de baja.',
      cancelButtonText: 'No,Cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {             
        this.form = new FormGroup({
          'idPago': new FormControl(idPago),
          'Estado': new FormControl('B'),
          'Baja_Usuario': new FormControl(this.user.Usuario),
          'Baja_Canal': new FormControl('W')
        })
        console.log(this.form.value);
        Swal.fire({
          title: '¡Espere!',
          html: 'Procesando solicitud.',
          heightAuto: false
        })
        Swal.showLoading();
        this.cobranzasService.BajaEstadoPago(this.form.value)
          .subscribe(
            res => {
              Swal.fire({
                title: 'Éxito',
                text: 'El pago fue dado de baja exitosamente.',
                type: 'success',
                heightAuto: false
              }).then(resp =>{
                if(resp.value == true){
                  this.ListadoPagos();
                }
              });
            },
            err => {
              Swal.fire({
                title: "Error",
                text: "No se pudo dar de baja el pago.",
                type: "error",
                allowOutsideClick: false,
                heightAuto: false
              });
            }
          )
      }
    })
  }
  
  

}
